import { Stratus } from '@stratusjs/runtime/stratus';
import 'angular-material';
import { cookie } from '@stratusjs/core/environment';
import { safeUniqueId } from '@stratusjs/core/misc';
const min = !cookie('env') ? '.min' : '';
const name = 'base';
const localPath = '@stratusjs/angularjs/src/directives';
Stratus.Directives.Base = function () {
    return {
        restrict: 'A',
        scope: {
            ngModel: '='
        },
        link: ($scope, $element, $attrs) => {
            const $ctrl = this;
            $scope.uid = safeUniqueId(name);
            Stratus.Instances[$scope.uid] = $scope;
            $scope.elementId = $element.elementId || $scope.uid;
            Stratus.Internals.CssLoader(Stratus.BaseUrl + Stratus.BundlePath + localPath + name + min + '.css').then();
            $scope.initialized = false;
            console.log('directive:', $ctrl, $scope, $element, $attrs);
        },
        templateUrl: Stratus.BaseUrl + Stratus.BundlePath + localPath + name + min + '.html'
    };
};

//# sourceMappingURL=base.js.map
